import {
  Beneficiaries,
  BeneficiaryType,
  Beneficiary,
  BeneficiaryPercentage,
  BeneficiaryCategories,
} from './beneficiaryInterfaces';

export const BENEFICIARY_CATEGORIES_KEYS: (keyof Beneficiaries)[] = [
  'age',
  'ethnic',
  'gender',
  'health',
  'social',
  'work',
];

export const setBeneficiaryValue = <T extends BeneficiaryType>(
  categories: Beneficiary<T>[] | undefined,
  name: T,
  percentage: number | null,
): Beneficiary<T>[] => {
  const category: Beneficiary<T> = { name, percentage };
  if (!categories) return [category];
  const index = categories?.findIndex(x => x.name === name);
  if (index === -1) return [...categories, { name, percentage }];
  categories[index].percentage = percentage;
  return categories;
};

export const getBeneficiaryValue = <T extends BeneficiaryType>(
  categories: Beneficiary<T>[] | undefined,
  name: T,
): number | null => {
  // because the database save percentage as `null` sometimes
  return categories?.find(x => x.name === name)?.percentage || null;
};

export const beneficiaryAgeValidation = (
  age: Beneficiaries['age'],
): boolean => {
  if (!age) return true;
  let allAdults: BeneficiaryPercentage = null;
  let nineteen: BeneficiaryPercentage = null;
  let seniors: BeneficiaryPercentage = null;

  let childrenAndYouth: BeneficiaryPercentage = null;
  let children: BeneficiaryPercentage = null;
  let youth: BeneficiaryPercentage = null;

  age.categories.forEach(x => {
    switch (x.name) {
      case 'Adults':
        allAdults = x.percentage;
        break;
      case 'Nineteen and older':
        nineteen = x.percentage;
        break;
      case 'Seniors':
        seniors = x.percentage;
        break;

      case 'Children and youth':
        childrenAndYouth = x.percentage;
        break;
      case 'Children':
        children = x.percentage;
        break;
      case 'Adolescents':
        youth = x.percentage;
        break;
    }
  });
  return (
    (allAdults || 0) +
      (nineteen || 0) +
      (seniors || 0) +
      (childrenAndYouth || 0) +
      (children || 0) +
      (youth || 0) ===
    100
  );
};

const isAnyPercentageSelected = (value: Beneficiary<BeneficiaryType>[]) => {
  for (const v of value) {
    if (v.percentage && v.percentage > 0) return true;
  }
  return false;
};

const atleastOneBeneficiarySelected = (beneficiaries: Beneficiaries) => {
  const values: (
    | BeneficiaryCategories<BeneficiaryType>
    | undefined
  )[] = Object.values(beneficiaries);
  for (const k of values) {
    if (k && k.categories.length > 0 && isAnyPercentageSelected(k.categories)) {
      return true;
    }
  }
  return false;
};

export const beneficiaryValidations = (
  beneficiaries: Beneficiaries,
): boolean => {
  // we can add more validations later
  return (
    beneficiaryAgeValidation(beneficiaries.age) &&
    atleastOneBeneficiarySelected(beneficiaries)
  );
};
